import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/glow-2.png")